import React from 'react';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { TwtRentalIncludes, TwtRentalPhotos } from '~/tenants/twt/package/rental/common';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { PackageFormNested } from '~/components/performable/PackageForm';
import TwtPhotoConfig, { TwtPhotoType } from '~/tenants/twt/performable/photo/TwtPhotoConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import TwtPhotosExtra from '~/tenants/twt/performable/photo/TwtPhotosExtra';
import TwtPhotosNeighborhood from '~/tenants/twt/performable/photo/TwtPhotosNeighborhood';
import TwtFloorplanConfig from '~/tenants/twt/performable/floorplan/TwtFloorplanConfig';

export default function TwtRentalFloorplanForm() {
  return (
    <>
      <TwtRentalIncludes />
      <PackageFormNested performable={TwtFloorplanConfig} />
      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <TwtRentalPhotos />
      </TenantPerformableAddOns>
    </>
  );
}
